import { t } from 'i18next';
import * as yup from 'yup';

import { YOUTUBE_URL_REGEX } from 'parts/components/PartDetails/Media/utils';

export const updateVideoSchema = () =>
  yup.object().shape({
    name: yup.string().nullable().label(t('labelTitle')).required(),
    video: yup
      .string()
      .nullable()
      .label(t('labelYoutubeLink'))
      .required()
      .matches(YOUTUBE_URL_REGEX, t('messageInvalidUrlFormat')),
  });
